import axios from 'axios'

class RevisionClientContractService {

    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
     * @author Edgar Escobedo
     * @description Get all changes in contract by syncfusion
     * @date 22-03-2023
     * @param {String} workflowExecutionId
     * @param {String} revisionClientContractId
     * @param {String} revisionId
     * @param {String} token
     * @returns {Object}
     * @memberof ServiceService
    */
    async getRevisionContract(workflowExecutionId, timezone, token) {
        let response = await axios.get(
            `${this.apiUrl}/revision-client-contract-service?workflowExecutionId=${workflowExecutionId}&timezone=${encodeURIComponent(timezone)}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }

    /**
     * @author Brayan Salas
     * @description Method to insert revisions from syncfusion in govo legal
     * @param {*} revisionClientContracList
     * @param {*} token
     * @return {*} 
     * @memberof RevisionClientContractService
     */
    async insertRevisionsClientDocument(revisionClientContracList, token) {
        let response = await axios.post(
            `${this.apiUrl}/revision-client-contract-service`,
            {
                revisionClientContracList
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },

            }
        );

        return response;
    }
}

export { RevisionClientContractService as default }